import React from "react";
import DashboardView from "Containers/General/DashboardView";
import CompanyList from "Containers/Company/CompanyList";
import CompanyTabs from "Containers/Company/CompanyTabs";
import UsersList from "Containers/User/UsersList";
import UserAdd from "Containers/User/UserAdd";
import TicketList from "Containers/Ticket/TicketList";
import CompanySecondaryDetailsList from "Containers/Company/CompanySecondaryDetailsList";
import ExpenseTypeList from "Containers/Expenses/ExpenseTypeList";
import ExpenseTypeAdd from "Containers/Expenses/ExpenseTypeAdd";
import ExpenseList from "Containers/Expenses/ExpenseList";
import ExpenseAdd from "Containers/Expenses/ExpenseAdd";
import PermissionsPageNew from "Containers/GroupsPermissions/PermissionsPageNew";
import ClientReportDashboard from "Containers/ClientReport/ClientReportDashboard";
import ClientReportList from "Containers/ClientReport/ClientReportList";
import ClientPaymentGatewayList from "Containers/ClientReport/ClientPaymentGatewayList";
import ClientPaymentGatewayDashboard from "Containers/ClientReport/ClientPaymentGatewayDashboard";
import SyncProgressReport from "Containers/ClientReport/SyncProgressReport";
import SchoolCollegeSync from "Components/AreaSearch/SchoolCollegeSync";

const Actions = {
  dashboard: {
    view: {
      codenames: [],
      action_code: "visible_dashboard_view",
      is_superuser_action: false,
      name: "View Dashboard",
      label: "Dashboard",
      action: "sub-menu",
      url: "/dashboard",
      component: <DashboardView />,
      permission_needed: true,
    },
    name: "Dashboard",
    type: "Dashboard",
  },
  company_list: {
    view: {
      codenames: [],
      action_code: "visible_company_list_view",
      is_superuser_action: false,
      name: "View Company List",
      label: "Company List",
      action: "sub-menu",
      url: "/company/list",
      component: <CompanyList />,
      permission_needed: true,
      associated_urls: ["/company/add", "/company/edit"],
    },
    create: {
      codenames: [],
      action_code: "visible_company_add",
      is_superuser_action: false,
      name: "Create Company",
      label: "Company",
      action: "action-url",
      url: "/company/add",
      component: <CompanyTabs />,
      permission_needed: true,
    },
    update: {
      codenames: [],
      action_code: "visible_company_change",
      is_superuser_action: false,
      name: "Update Company",
      label: "Company",
      action: "action",
      url: "/company/edit",
      permission_needed: true,
    },
    delete: {
      codenames: [],
      action_code: "visible_company_delete",
      is_superuser_action: false,
      name: "Delete Company",
      label: "Company",
      action: "action",
      permission_needed: true,
    },
    name: "Company List",
    type: "Company List",
  },
  users_list: {
    view: {
      codenames: [],
      action_code: "visible_users_list_view",
      is_superuser_action: false,
      name: "View Users List",
      label: "Users List",
      action: "sub-menu",
      url: "/user/list",
      component: <UsersList />,
      permission_needed: true,
      associated_urls: ["/user/add"],
    },
    create: {
      codenames: [],
      action_code: "visible_user_add",
      is_superuser_action: false,
      name: "Create User",
      label: "User",
      action: "action-url",
      url: "/user/add",
      component: <UserAdd />,
      permission_needed: true,
    },
    update: {
      codenames: [],
      action_code: "visible_user_change",
      is_superuser_action: false,
      name: "Update User",
      label: "User",
      action: "action",
      permission_needed: true,
    },
    delete: {
      codenames: [],
      action_code: "visible_user_delete",
      is_superuser_action: false,
      name: "Delete User",
      label: "User",
      action: "action",
      permission_needed: true,
    },
    name: "Users List",
    type: "Users List",
  },
  ticket_list: {
    view: {
      codenames: [],
      action_code: "visible_ticket_list_view",
      is_superuser_action: false,
      name: "View Ticket List",
      label: "Ticket List",
      action: "sub-menu",
      url: "/ticket/list",
      component: <TicketList />,
      permission_needed: true,
    },
    name: "Ticket list",
    type: "Ticket list",
  },
  area_search: {
    view: {
      codenames: [],
      action_code: "visible_area_search_view",
      is_superuser_action: false,
      name: "View All Schools",
      label: "All Schools",
      action: "sub-menu",
      url: "/area-search",
      component: <SchoolCollegeSync />,
      permission_needed: true,
    },
    name: "All Schools",
    type: "Sales & Support",
  },
  company_billing_details: {
    view: {
      codenames: [],
      action_code: "visible_company_billing_details_view",
      is_superuser_action: false,
      name: "View Company Billing Details",
      label: "Company Billing Details",
      action: "sub-menu",
      url: "/companysecondarydetails/list",
      component: <CompanySecondaryDetailsList />,
      permission_needed: true,
      associated_urls: ["/companysecondarydetails"],
    },
    name: "Company Billing details",
    type: "Basic Details",
  },
  expense_type: {
    view: {
      codenames: [],
      action_code: "visible_expense_type_view",
      is_superuser_action: false,
      name: "View Expense Type",
      label: "Expense Type",
      action: "sub-menu",
      url: "/expenses/expense-type/list",
      component: <ExpenseTypeList />,
      permission_needed: true,
      associated_urls: ["/expenses/expense-type/add"],
    },
    create: {
      codenames: [],
      action_code: "visible_expense_type_add",
      is_superuser_action: false,
      name: "Create Expense Type",
      label: "Expense Type",
      action: "action-url",
      url: "/expenses/expense-type/add",
      component: <ExpenseTypeAdd />,
      permission_needed: true,
    },
    name: "Expense Type",
    type: "Expenses",
  },
  expense_list: {
    view: {
      codenames: [],
      action_code: "visible_expense_list_view",
      is_superuser_action: false,
      name: "View Expense List",
      label: "Expense List",
      action: "sub-menu",
      url: "/expenses/expense/list",
      component: <ExpenseList />,
      permission_needed: true,
      associated_urls: ["/expenses/expense/add"],
    },
    create: {
      codenames: [],
      action_code: "visible_expense_add",
      is_superuser_action: false,
      name: "Create Expense",
      label: "Expense",
      action: "action-url",
      url: "/expenses/expense/add",
      component: <ExpenseAdd />,
      permission_needed: true,
    },
    name: "Expense List",
    type: "Expenses",
  },
  permissions_menu: {
    view: {
      codenames: [],
      action_code: "visible_permissions_menu_view",
      is_superuser_action: false,
      name: "View Permissions",
      label: "Permissions",
      action: "sub-menu",
      url: "/permission/list",
      component: <PermissionsPageNew />,
      permission_needed: true,
    },
    name: "Permissions",
    type: "Permissions",
  },
  client_report_dashboard: {
    view: {
      codenames: [],
      action_code: "visible_client_report_dashboard_view",
      is_superuser_action: false,
      name: "View Client Report Dashboard",
      label: "Dashboard",
      action: "sub-menu",
      url: "/client-report/dashboard",
      component: <ClientReportDashboard />,
      permission_needed: true,
    },
    name: "Dashboard",
    type: "Client Report",
  },
  client_report: {
    view: {
      codenames: [],
      action_code: "visible_client_report_view",
      is_superuser_action: false,
      name: "View Client Report",
      label: "Report",
      action: "sub-menu",
      url: "/client-report/report",
      component: <ClientReportList />,
      permission_needed: true,
    },
    create: {
      codenames: [],
      action_code: "visible_client_report_sync",
      is_superuser_action: true,
      name: "Sync Client Report",
      label: "Sync Client Report",
      action: "action",
      permission_needed: true,
    },
    name: "Report",
    type: "Client Report",
  },
  client_report_payment_gateway_dashboard: {
    view: {
      codenames: [],
      action_code: "visible_client_report_payment_gateway_dashboard_view",
      is_superuser_action: false,
      name: "View Payment Gateway Dashboard",
      label: "Payment Gateway Dashboard",
      action: "sub-menu",
      url: "/client-report/payment-gateway/dashboard",
      component: <ClientPaymentGatewayDashboard />,
      permission_needed: true,
    },
    name: "Payment Gateway Dashboard",
    type: "Client Report",
  },
  client_report_payment_gateway: {
    view: {
      codenames: [],
      action_code: "visible_client_report_payment_gateway_view",
      is_superuser_action: false,
      name: "View Payment Gateway Online Transactions",
      label: "Payment Gateway",
      action: "sub-menu",
      url: "/client-report/payment-gateway",
      component: <ClientPaymentGatewayList />,
      permission_needed: true,
    },
    name: "Payment Gateway",
    type: "Client Report",
  },
  client_report_list: {
    view: {
      codenames: [],
      action_code: "visible_client_report_list_view",
      is_superuser_action: false,
      name: "View Client Report List",
      label: "Report List",
      action: "action-url",
      url: "/client-report/list",
      component: <ClientReportList />,
      permission_needed: true,
    },
    name: "Report List",
    type: "Client Report",
  },
  client_sync_progress: {
    view: {
      codenames: [],
      action_code: "visible_client_sync_progress_view",
      is_superuser_action: false,
      name: "View Sync Progress",
      label: "Sync Progress",
      action: "sub-menu",
      url: "/client-report/sync-progress",
      component: <SyncProgressReport />,
      permission_needed: true,
    },
    name: "Sync Progress",
    type: "Client Report",
  },
};

export default Actions;
